import React from "react";
import { MailchimpSubscribeForm } from "./MailchimpSubscribeForm";

function SubscribeWidget() {
    return (
        <div className="subscribeWidgetContainer">
            {/* Если хочешь добавить текст над формой, раскомментируй строку ниже: */}
            {/* <h3 style={{color: 'white', marginBottom: '10px'}}>Stay updated!</h3> */}

            <MailchimpSubscribeForm />
        </div>
    );
}

export default SubscribeWidget;